import React, { useState } from "react";
import { createClassname } from "../../../../../../../utils";

export const Benefits = ({ signUpModel }) => {
  const { benefitsTitle, benefitsDescription, benefitsList } = signUpModel;
  const [isOpened, setIsOpened] = useState(false);

  if (!benefitsTitle || !benefitsDescription || !benefitsList) return null;

  return (
    <div className={"sign-up__benefits"}>
      <div
        className={createClassname("sign-up__benefits-title", "opened", isOpened)}
        onClick={() => setIsOpened(!isOpened)}
      >
        {benefitsTitle}
      </div>
      <div
        className={createClassname("sign-up__benefits-description", "opened", isOpened)}
        dangerouslySetInnerHTML={{ __html: benefitsDescription }}></div>
      <ul className={createClassname("sign-up__benefits-list", "opened", isOpened)}>
        {benefitsList.length && benefitsList.map(({ benefitsItem }) => (
          <li className={"sign-up__benefits-list-item"}>{benefitsItem}</li>
        ))}
      </ul>
    </div>
  )
}
